import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '@/lib/firebase/config';
import { findUserByPhone } from '@/lib/firebase/auth/user';
import { requestPasswordResetCore, type ResetOutcome } from '@/lib/auth/passwordReset';

const deps = {
  findEmailByPhone: async (local: string) => {
    const u = await findUserByPhone(local);
    const email = (u as any)?.email;
    return typeof email === 'string' && email.trim() ? email.trim() : null;
  },
  sendReset: (email: string) => sendPasswordResetEmail(auth, email),
};

/** Forgot-password: email or phone in, Firebase reset mail out. */
export function requestPasswordReset(input: string): Promise<ResetOutcome> {
  return requestPasswordResetCore(input, deps);
}

/**
 * The invite for an email-identified managed user is the same Firebase
 * reset mail. Returns false instead of throwing so callers can offer a
 * "resend" action — the account already exists by the time this runs.
 */
export async function sendInviteEmail(email: string): Promise<boolean> {
  try {
    await sendPasswordResetEmail(auth, email);
    return true;
  } catch (e) {
    console.warn('[invite] sendPasswordResetEmail failed:', e);
    return false;
  }
}
